import type { MapAccessDeniedReason } from "@dailywars/core/entitlements/types";

export type MapAccessUpsellReason = Extract<
  MapAccessDeniedReason,
  "premium-required" | "past-day-requires-premium"
>;

export const MAP_ACCESS_UPSELL_COPY: Record<
  MapAccessUpsellReason,
  { title: string; description: string }
> = {
  "premium-required": {
    title: "Upgrade required",
    description: "Premium maps are only available to premium subscribers.",
  },
  "past-day-requires-premium": {
    title: "Upgrade required",
    description: "You need a premium subscription to play maps from previous days.",
  },
};

export const REPLAY_REQUIRES_PREMIUM_COPY = "Only premium players can replay maps.";

export function mapAccessUpsellCopy(reason: MapAccessUpsellReason): {
  title: string;
  description: string;
} {
  return MAP_ACCESS_UPSELL_COPY[reason];
}

export function isMapAccessUpsellReason(
  reason: MapAccessDeniedReason,
): reason is MapAccessUpsellReason {
  return reason in MAP_ACCESS_UPSELL_COPY;
}
